import { render, staticRenderFns } from "./company-view.vue?vue&type=template&id=7772d046&scoped=true"
import script from "./company-view.vue?vue&type=script&lang=js"
export * from "./company-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7772d046",
  null
  
)

export default component.exports